import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientProductsRoute } from '../../route';
import { DEFAULT_LOAD_MORE, DEFAULT_PAGE_NUMBER } from '../constants';

import { clientCardsFilterFormSchema } from './ClientCardsFilter/clientCardsFilterFormSchema';

export const clientCardsRoute = createRoute({
	path: '/cards',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientCardsPage'),
		'ClientCardsPage',
	),
	validateSearch: z.object({
		openedCard: z.string().optional(),
		filter: clientCardsFilterFormSchema.prefault({ cardState: 'active' }),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	}),
});
